import * as gameStateFunctions from "./game-state-functions.js";
import * as coreFunctions from "./core-functions.js";
import * as respawn from "./respawn.js";

export default function Game(gameState, aiHandler) {
    function start() {
        gameState.gameActive = true;
    }

    function stop() {
        gameState.gameActive = false;
    }

    // Enter the cosmetic post-round "victory lap": the round is already scored, but keep
    // the sim RUNNING (re-activate it) so the last worm(s) keep driving, still pick up
    // power-ups (twin etc. activate as normal) and can still crash - none of which changes
    // the locked standings. update() below skips the round-end stop while this is set. The
    // caller runs plain update() during the lap (no special code), then prepareNextGame().
    function enterVictoryLap() {
        gameState.victoryLap = true;
        gameState.gameActive = true;
        // Announce the lap as a game event carrying the winner (the last one
        // standing), so renderers can celebrate at their head (victory
        // animations) and streams/debug tools can name them. Pushed HERE so
        // local play and the online host emit it identically.
        // A knock-out round (endAtAlive, see update) ends with several survivors:
        // nobody won it, so the lap names no winner.
        var survivors = gameStateFunctions.getAlivePlayers(gameState);
        gameState.gameEvents.push({
            type: "victory_lap",
            time: gameState.gameTime,
            playerId: survivors.length === 1 ? survivors[0].id : undefined
        });
    }

    function update(deltaTime) {
        if (!isActive(gameState) || deltaTime <= 0) {
            return;
        }
        gameState.gameTime += deltaTime;
        aiHandler.update(gameState, deltaTime);

        if (gameStateFunctions.isInStartPhase(gameState)) {
            coreFunctions.updatePlayers(gameState, deltaTime);
            coreFunctions.updateWorms(gameState, deltaTime);
        } else {
            coreFunctions.updatePowerUps(gameState, deltaTime);
            coreFunctions.updateEffects(gameState, deltaTime);
            coreFunctions.updatePlayers(gameState, deltaTime);
            coreFunctions.updateWormJumps(gameState, deltaTime);
            coreFunctions.updateWorms(gameState, deltaTime);
            coreFunctions.updateCollision(gameState);
            if (gameState.respawn) {
                respawn.update(gameState);
            }
        }

        // A round ends when only the last worm is standing. With a single player
        // (solo practice) there's no "last one standing", so it runs until that
        // worm crashes (0 alive) instead of ending immediately. During the victory lap the
        // round is already over, so don't stop again - just keep the cosmetic sim running.
        // A knock-out round (Royale) ends earlier: as soon as only `endAtAlive`
        // players are left, i.e. once the round's quota has crashed.
        var endThreshold = typeof gameState.endAtAlive === "number"
            ? gameState.endAtAlive
            : gameState.players.length <= 1 ? 0 : 1;
        if (!gameState.victoryLap && gameStateFunctions.getAlivePlayers(gameState).length <= endThreshold) {
            stop(gameState);
        }
        // A Respawn round (respawn.js) ends on its timer instead.
        if (gameState.respawn && respawn.isTimeUp(gameState)) {
            stop(gameState);
        }
    }

    function isActive() {
        return gameState.gameActive;
    }

    return {
        gameState,
        start,
        stop,
        isActive,
        update,
        enterVictoryLap
    };
};
